const getGoogleAnalyticsClientId = (): string | null => {
  const regex = /(?:^|;)\s*_ga=([^;]*)/
  const match = regex.exec(document.cookie)
  const raw = match ? decodeURIComponent(match[1]) : null
  if (raw) {
    const clientRegex = /(\d+\.\d+)$/
    const clientMatch = clientRegex.exec(raw)
    return clientMatch ? clientMatch[1] : null
  }
  return null
}

export const getPageProperties = () => {
  const properties: Record<string, any> = {}

  properties.page_title = document.title
  properties.url = window.location.href
  properties.path = window.location.pathname

  if (document.referrer) {
    properties.referrer = document.referrer
    try {
      const referrerUrl = new URL(document.referrer)
      properties.referrer_hostname = referrerUrl.hostname
    } catch (e) {
      console.warn('Invalid referrer URL:', document.referrer, e)
    }
  }

  const clientId = getGoogleAnalyticsClientId()
  if (clientId) {
    properties.client_id = clientId
  }

  return properties
}
